import React from "react"
import Typography from "@material-ui/core/Typography"
import Card from "@material-ui/core/Card"
import useStyles from "../NextStep/styles"
import CardContent from "@material-ui/core/CardContent"
import Box from "@material-ui/core/Box"

const NextStep = ({ message, shootDate, daysAway }) => {
  const classes = useStyles()
  return (
    <Card className={classes.root} style={{
      marginBottom: "40px"
    }}>
      <CardContent>
        <Typography className={classes.title} variant="h2">
          Next Step
        </Typography>
        <Typography className={classes.body} variant="body1">
          {message}
        </Typography>
        <Typography className={classes.subtitle} variant="h2">
          Shoot is scheduled for:
        </Typography>
        <Box
          display="flex"
          flexWrap="nowrap"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography className={classes.date}>{shootDate}</Typography>
          <Typography className={classes.numDays}>{daysAway}</Typography>
        </Box>
      </CardContent>
    </Card>
  )
}

export default NextStep
